<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <div class="tabs large">
          <ul>
            <li :class="{'active': $route.name === 'Dashboard'}">
              <router-link active-class="inactive" exact-active-class="active" :to="{ name: 'Dashboard'}">Oversikt</router-link>
            </li>
            <li :class="{'active': $route.name === 'DashboardPageFailedOppgjor'}" v-if="hasAccess('accounting')">
              <router-link active-class="inactive" exact-active-class="active" :to="{ name: 'DashboardPageFailedOppgjor'}">Oppgjor som har feilet</router-link>
            </li>
            <li :class="{'active': $route.name === 'DashboardPageUferdigeKontrakt'}">
              <router-link active-class="inactive" exact-active-class="active" :to="{ name: 'DashboardPageUferdigeKontrakt'}">Uferdige kontrakter</router-link>
            </li>
            <li :class="{'active': $route.name === 'DashboardPageUferdigeObjekt'}">
              <router-link active-class="inactive" exact-active-class="active" :to="{ name: 'DashboardPageUferdigeObjekt'}">Uferdige objekter</router-link>
            </li>
            <li :class="{'active': $route.name === 'DashboardPageOppgaver'}">
              <router-link active-class="inactive" exact-active-class="active" :to="{ name: 'DashboardPageOppgaver'}">Oppgaver</router-link>
            </li>
          </ul>
        </div>
      </div>

      <!-- Statuslist dropdown -->
      <template v-if="showStatusDropdown">
        <div class="cell shrink">
          <div class="select-container has-popover" :class="{'popover-active': statusPopoverActive}" @click="toggleStatusPopover()">
            <a class="button-select" href="javascript:;">
              <span class="title"><span>{{selectedStatus}}</span></span>
              <!-- <span class="label gray small">495</span>  -->
              <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-select"></use></svg></span>
            </a>

            <span class="popover button-select-popover button-select-popover align-x-right align-y-bottom large">
              <ul>
                <li v-for="item in statusList" :key="item.key" :class="{'active': item.key === selectedStatusId}">
                  <a href="javascript:;" @click="setStatus(item.key)"><span>{{item.val}}</span><!-- <span class="label gray small">495</span>--></a>
                </li>
              </ul>
            </span>
          </div>
        </div>
      </template>
      <!-- Statuslist dropdown -->

      <!-- Possibly a bruker list popover -->
      <template v-if="showBrukerDropdown">
        <div class="cell shrink">
          <div class="select-container has-popover" :class="{'popover-active': brukerPopoverActive}" @click="toggleBrukerPopover()">
            <a class="button-select" href="javascript:;">
              <span class="title"><span>{{selectedBruker}}</span></span>
              <!-- <span class="label gray small">495</span>  -->
              <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-select"></use></svg></span>
            </a>

            <span class="popover button-select-popover button-select-popover align-x-right align-y-bottom large">
              <div class="custom-scrollbar">
                <ul>
                  <li v-for="item in brukerList" :key="item.key" :class="{'active': item.key === selectedBrukerId}">
                    <a href="javascript:;" @click="setBruker(item.key)"><span>{{item.val || item.key}}</span><!-- <span class="label gray small">495</span>--></a>
                  </li>
                </ul>
              </div>
            </span>
          </div>
        </div>
      </template>
      <!-- // Possibly a bruker list popover -->
    </div>

    <router-view v-bind:brukerList="brukerList" :brukerId="selectedBrukerId" :statusId="selectedStatusId" :key="$route.path"></router-view>
  </div>
</template>

<script>
import BrukerService from '@/services/BrukerService'

export default {
  name: 'Dashboard',
  data () {
    return {
      brukerList: [],
      statusList: [
        { key: null, val: 'Alle statuser' },
        { key: 'pending', val: 'Ubehandlet' },
        { key: 'in-progress', val: 'Under behandling' },
        { key: 'on-hold', val: 'På vent' },
        { key: 'resolved', val: 'Ferdigbehandlet' }
      ],
      statusPopoverActive: false,
      brukerPopoverActive: false,
      selectedStatusId: null,
      selectedBrukerId: null
    }
  },
  computed: {
    canSelectBruker: function () {
      return this.hasAccess('admin')
    },
    showBrukerDropdown: function () {
      if (!this.canSelectBruker) {
        return false
      }

      switch (this.$route.name) {
        case 'DashboardPageUferdigeKontrakt':
        case 'DashboardPageUferdigeObjekt':
        case 'DashboardPageOppgaver':
          return true
        default:
          return false
      }
    },
    showStatusDropdown: function () {
      switch (this.$route.name) {
        case 'DashboardPageOppgaver':
          return true
        default:
          return false
      }
    },
    selectedStatus: function () {
      if (this.statusList && this.statusList.length) {
        const found = this.statusList.find(x => x.key === this.selectedStatusId)

        if (found) {
          return found.val || found.key
        }
      }

      return 'Alle statuser'
    },
    selectedBruker: function () {
      if (this.brukerList && this.brukerList.length) {
        const found = this.brukerList.find(x => x.key === this.selectedBrukerId)

        if (found) {
          return found.val || found.key
        }
      }

      return 'Alle kontraktsansvarlige'
    }
  },
  beforeDestroy () {
    window.jQuery('body').removeClass('show-sidebar-xxlarge')
  },
  created () {
    window.jQuery('body').addClass('show-sidebar-xxlarge')

    const vm = this
    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.statusPopoverActive = false
        vm.brukerPopoverActive = false
      }
    })

    if (this.canSelectBruker) {
      this.loadBrukerList()
    }

    this.setBrukerByLocalstorage(this.$route.name)
    this.setStatusByLocalstorage(this.$route.name)
  },
  beforeRouteUpdate: function (to, from, next) {
    this.setBrukerByLocalstorage(to.name)
    this.setStatusByLocalstorage(to.name)
    next()
  },
  methods: {
    setBrukerByLocalstorage: function (routeName) {
      if (!this.canSelectBruker) {
        this.selectedBrukerId = null
        return
      }

      switch (routeName) {
        case 'DashboardPageUferdigeKontrakt':
          this.selectedBrukerId = localStorage.dbw_uferdige_kontrakt || null
          break
        case 'DashboardPageUferdigeObjekt':
          this.selectedBrukerId = localStorage.dbw_uferdige_objekt || null
          break
        case 'DashboardPageOppgaver':
          this.selectedBrukerId = localStorage.dbw_oppgaver_bruker || null
          break
        default:
          this.selectedBrukerId = null
      }
    },
    setStatusByLocalstorage: function (routeName) {
      switch (routeName) {
        case 'DashboardPageOppgaver':
          this.selectedStatusId = localStorage.dbw_oppgaver_status || null
          break
        default:
          this.selectedStatusId = null
      }
    },
    setBruker: function (itemId) {
      this.selectedBrukerId = itemId || null

      switch (this.$route.name) {
        case 'DashboardPageUferdigeKontrakt':
          if (this.selectedBrukerId) {
            localStorage.dbw_uferdige_kontrakt = this.selectedBrukerId
          } else {
            localStorage.removeItem('dbw_uferdige_kontrakt')
          }
          break
        case 'DashboardPageUferdigeObjekt':
          if (this.selectedBrukerId) {
            localStorage.dbw_uferdige_objekt = this.selectedBrukerId
          } else {
            localStorage.removeItem('dbw_uferdige_objekt')
          }
          break
        case 'DashboardPageOppgaver':
          if (this.selectedBrukerId) {
            localStorage.dbw_oppgaver_bruker = this.selectedBrukerId
          } else {
            localStorage.removeItem('dbw_oppgaver_bruker')
          }
          break
      }
    },
    setStatus: function (itemId) {
      this.selectedStatusId = itemId || null

      switch (this.$route.name) {
        case 'DashboardPageOppgaver':
          if (this.selectedStatusId) {
            localStorage.dbw_oppgaver_status = this.selectedStatusId
          } else {
            localStorage.removeItem('dbw_oppgaver_status')
          }
          break
      }
    },
    toggleBrukerPopover: function () {
      this.brukerPopoverActive = !this.brukerPopoverActive
      this.statusPopoverActive = false
    },
    toggleStatusPopover: function () {
      this.statusPopoverActive = !this.statusPopoverActive
      this.brukerPopoverActive = false
    },
    loadBrukerList: function () {
      this.brukerList.unshift({key: null, val: 'Laster...'})

      BrukerService.dropdown('Brukernavn')
        .then((response) => {
          this.brukerList = response.data
          this.brukerList.unshift({key: null, val: 'Alle kontaktsansvarlige'})
        })
        .catch((error) => {
          console.log(error)
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn brukere')

          this.brukerList = []
          this.brukerList.unshift({key: null, val: 'Alle kontaktsansvarlige'})
        })
        .then(() => {
          // Nothing to do anymore...
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Dashboard/Dashboard.vue